export const isExternalUri = (uri: string) => /^([a-z+.-]+):/.test(uri);

export const getLinkTarget = (uri: string) => (
    isExternalUri(uri) ? '_blank' : '_self'
);
